import {selection} from "d3-selection";

var Selection = selection.prototype.constructor;

export default function() {
  return new Selection(this._groups, this._parents);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-transition/src/transition/selection.js
// module id = 1295
// module chunks = 0